module.exports = __webpack_public_path__ + "static/media/signup.d11dcb75.svg";